<template>
  <div class="header">
    <div class="button-back" v-if="isStartFromSchedule" @click="goSchedule">
      <span class="btn-icon fa fa-long-arrow-left"></span>
    </div>
    <div>
      <div class="event-info">
        <div class="session-wrapper">
          <div class="name">{{ session.MovieName }}</div>
          <div class="tag" v-if="session.Format">{{ session.Format.Name }}</div>
          <div class="tag">{{ `${movie.Age}+` }}</div>
        </div>
        <div class="cinema-wrapper">
          <div class="cinema-hall-name" v-if="session.Hall">
            {{ theatre.Name }}, {{ session.Hall.Name }}
          </div>
        </div>
      </div>
      <div class="time-wrapper">
        <div class="time-date" v-if="session.DateTime">
          {{ session.DateTime | moment('dddd, D MMMM в H:mm') }}
        </div>
      </div>
      <div class="contact" v-if="theatre.SupportPhone">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">{{ theatre.SupportPhone }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '@/types';
import urlQueryParts from '../../../helpers/urlQueryParts';

export default {
  name: 'Header',

  computed: {
    ...mapState([
      'theatre',
      'session',
      'movie',
      'setting',
      'isStartFromSchedule',
      'data',
    ]),
  },

  mounted() {
    this.$moment.locale('ru');

    console.log(this.$router, 'this.$router');
    console.log(this.$route, 'this.$router1');

    addEventListener('popstate', this.logBrowserBtnBack);
  },

  methods: {
    goSchedule() {
      const { theatreId, crmSystemId, theatres, flag, cityId } =
        this.data.afterUnmountedGeneralSchedule;

      this.$store.commit(types.CLEAR_CART);
      this.$store.dispatch('logBackToGeneralSchedule');
      this.$store.dispatch('logBack');

      if (theatreId || crmSystemId || theatres || flag) {
        this.$router.push(
          `/generalSchedule${urlQueryParts({
            cityId,
            theatreId,
            crmSystemId,
            theatres,
            flag,
          })}`,
        );
      } else {
        this.$router.push(`/generalSchedule/${cityId}`);
      }
    },

    logBrowserBtnBack(e) {
      if (e.target.location.pathname.includes('generalSchedule')) {
        this.$store.commit(types.CLEAR_CART);
        this.$store.dispatch('logBackToGeneralSchedule');
      }
      this.$store.dispatch('logBack');
      removeEventListener('popstate', this.logBrowserBtnBack);
    },
  },
};
</script>

<style lang="scss" scoped src="./Header.scss"></style>
